// 管理后台 API 服务
// 根据当前访问地址自动判断 API 地址
const API_BASE = process.env.REACT_APP_API_BASE || 
  (window.location.hostname === 'localhost' ? 'http://localhost:8000' : window.location.origin);

// 获取认证头 - 使用管理员专属token
const getAuthHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};

// 通用请求方法
const request = async (url, options = {}) => {
  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin/login';
    throw new Error('未授权，请重新登录');
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: '请求失败' }));
    throw new Error(error.detail || '请求失败');
  }

  return response.json();
};

// ============ 仪表盘 ============
export const getDashboard = () => request('/api/admin/dashboard');

// ============ 用户管理 ============
export const getUsers = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/users?${query}`);
};

export const getUser = (id) => request(`/api/admin/users/${id}`);

export const createUser = (data) => request('/api/admin/users', {
  method: 'POST',
  body: JSON.stringify(data),
});

export const updateUser = (id, data) => request(`/api/admin/users/${id}`, {
  method: 'PUT',
  body: JSON.stringify(data),
});

export const resetUserPassword = (id, newPassword) => request(`/api/admin/users/${id}/reset-password`, {
  method: 'POST',
  body: JSON.stringify({ new_password: newPassword }),
});

export const deleteUser = (id) => request(`/api/admin/users/${id}`, {
  method: 'DELETE',
});

// ============ 角色管理 ============
export const getRoles = () => request('/api/admin/roles');

export const getRole = (id) => request(`/api/admin/roles/${id}`);

export const createRole = (data) => request('/api/admin/roles', {
  method: 'POST',
  body: JSON.stringify(data),
});

export const updateRole = (id, data) => request(`/api/admin/roles/${id}`, {
  method: 'PUT',
  body: JSON.stringify(data),
});

export const deleteRole = (id) => request(`/api/admin/roles/${id}`, {
  method: 'DELETE',
});

export const getPermissions = () => request('/api/admin/permissions');

// ============ 日志管理 ============
export const getLoginLogs = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/logs/login?${query}`);
};

export const getOperationLogs = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/logs/operation?${query}`);
};

// ============ 数据统计 ============
export const getStatsOverview = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/stats/overview?${query}`);
};

export const getDailyStats = (days = 30) => request(`/api/admin/stats/daily?days=${days}`);

export const getTopUsers = (limit = 10) => request(`/api/admin/stats/users/top?limit=${limit}`);

// ============ 系统设置 ============
export const getSettings = () => request('/api/admin/settings');

export const updateSetting = (key, value) => request(`/api/admin/settings/${key}`, {
  method: 'PUT',
  body: JSON.stringify({ value }),
});

// ============ 公告管理 ============
export const getAnnouncements = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/announcements?${query}`);
};

export const createAnnouncement = (data) => request('/api/admin/announcements', {
  method: 'POST',
  body: JSON.stringify(data),
});

export const updateAnnouncement = (id, data) => request(`/api/admin/announcements/${id}`, {
  method: 'PUT',
  body: JSON.stringify(data),
});

export const deleteAnnouncement = (id) => request(`/api/admin/announcements/${id}`, {
  method: 'DELETE',
});

// ============ 历史记录管理 ============
export const getHistory = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/history?${query}`);
};

// ============ 留言管理 ============
export const getMessages = (params) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/messages?${query}`);
};

export const getMessage = (id) => request(`/api/admin/messages/${id}`);

export const replyMessage = (id, replyContent) => request(`/api/admin/messages/${id}/reply`, {
  method: 'POST',
  body: JSON.stringify({ reply_content: replyContent }),
});

export const updateMessageStatus = (id, status) => request(`/api/admin/messages/${id}/status?status=${status}`, {
  method: 'PUT',
});

export const deleteMessage = (id) => request(`/api/admin/messages/${id}`, {
  method: 'DELETE',
});
